<template>
  <div class="grid person">
    <div class="grid__col--1 modal-people__icon-container h-center-align h-no-padding">
      <span class="glyphicon glyphicon-user queue-detail__glyph modal-people__icon modal-people__icon--blank" aria-hidden="true"></span>
    </div>
    <div class="grid__col--11 h-no-padding h-no-margin modal-people__text-container">
      <div class="modal-people__author modal-people__author--blank modal-people--blank"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PersonSkeleton',
  };
</script>
